document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-control-methods-slider]').forEach(function (slider) {
    var section = slider.closest('.control-methods');
    if (!section || typeof Swiper === 'undefined') return;

    new Swiper(slider, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        900: {
          slidesPerView: 3,
          spaceBetween: 24,
        }
      },
    });
  });
});
